import * as React from 'react';
import { SVGProps } from 'react';

const IconVideoSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V7l2 1V4L8 5V4a1 1 0 0 0-1-1H3z" />
  </svg>
);
export default IconVideoSizeXs;
